import { Component, OnInit, OnDestroy } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ActivatedRoute, Router } from '@angular/router';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';
import { MatIconModule } from '@angular/material/icon';
import { MatButtonModule } from '@angular/material/button';
import { MatSnackBar, MatSnackBarModule } from '@angular/material/snack-bar';
import { JjamesButtonComponent } from 'shared-lib';
import { JJamesCardComponent } from 'shared-lib';
import { CustomerService } from '../../../api/gen/api/customer.service';
import { OperatorGroupService } from '../../../api/gen/api/operatorGroup.service';
import { ParkingOperatorDto } from '../../../api/gen/model/parkingOperatorDto';
import { CustomerDto } from '../../../api/gen/model/customerDto';
import { OperatorGroupDto } from '../../../api/gen/model/operatorGroupDto';

@Component({
    selector: 'app-operator-group-members',
    imports: [
        CommonModule,
        MatProgressSpinnerModule,
        MatIconModule,
        MatButtonModule,
        MatSnackBarModule,
        JjamesButtonComponent,
        JJamesCardComponent
    ],
    templateUrl: './operator-group-members.component.html',
    styleUrl: './operator-group-members.component.scss'
})
export class OperatorGroupMembersComponent implements OnInit, OnDestroy {
    customerId: string | null = null;
    operatorGroupId: string | null = null;
    customer: CustomerDto | null = null;
    operatorGroup: OperatorGroupDto | null = null;

    operators: ParkingOperatorDto[] = [];
    isLoading = false; constructor(
        private route: ActivatedRoute,
        private router: Router,
        private customerService: CustomerService,
        private operatorGroupService: OperatorGroupService,
        private snackBar: MatSnackBar
    ) { }

    ngOnInit(): void {
        this.customerId = this.route.snapshot.paramMap.get('customerId');
        this.operatorGroupId = this.route.snapshot.paramMap.get('groupId');

        if (!this.customerId || !this.operatorGroupId) {
            this.snackBar.open('Invalid customer or operator group ID', 'Close', { duration: 3000 });
            this.router.navigate(['/customer-management']);
            return;
        }

        this.loadCustomerAndGroup();
    }

    ngOnDestroy(): void {
        // Cleanup if needed
    }

    private loadCustomerAndGroup(): void {
        if (!this.customerId || !this.operatorGroupId) return;

        this.isLoading = true;

        this.customerService.customerCustomerIdGet(this.customerId, true).subscribe({
            next: (customer) => {
                if (customer) {
                    this.customer = customer;
                    this.operatorGroup = customer.operatorGroups?.find(
                        group => group.id === this.operatorGroupId
                    ) || null;

                    if (!this.operatorGroup) {
                        this.snackBar.open('Operator group not found', 'Close', { duration: 3000 });
                        this.router.navigate(['/customer-management', this.customerId]);
                        return;
                    }
                }
                this.loadGroupMembers();
            },
            error: (error) => {
                console.error('Error loading customer:', error);
                this.snackBar.open('Error loading customer details', 'Close', { duration: 3000 });
                this.isLoading = false;
            }
        });
    }

    private loadGroupMembers(): void {
        if (!this.operatorGroupId) return;

        this.operatorGroupService.operatorGroupsOperatorGroupIdGet(this.operatorGroupId, true, false, false).subscribe({
            next: (group) => {
                const allOperators = (group?.operatorGroupMemberships ?? [])
                    .filter(m => m.isActive && m.operator)
                    .map(m => m.operator!);
                this.operators = allOperators;
                this.isLoading = false;
            },
            error: (error) => {
                console.error('Error loading group members:', error);
                this.snackBar.open('Error loading group members', 'Close', { duration: 3000 });
                this.isLoading = false;
            }
        });
    }

    onViewOperatorDetails(operator: ParkingOperatorDto): void {
        if (operator.id) {
            this.router.navigate(['/user-management/operator-management/edit', operator.id]);
        }
    }

    goBack(): void {
        if (this.customerId) {
            this.router.navigate(['/customer-management', this.customerId]);
        } else {
            this.router.navigate(['/customer-management']);
        }
    }
}
